<template lang="pug">
  .locations
    .tabs-header.kapra-neue.bold.upper.xs-f-medium.md-f-large.max-at-tweak.xs-12
      button.btn-reset.tab.upper(@click="$emit('tab-click',true)" :class="{active: mrTabActive}") {{ mrTabText }}
      button.btn-reset.tab.upper(@click="$emit('tab-click',false)" :class="{active: !mrTabActive}") {{ retailTabText }}
    .cards.mt-300m
      .locationCard(v-for="loc in locationList" :class="{active:isLocationActive(loc)}" @click="$emit('card-click',loc)")
        .icon
          .active-icon(v-if="isLocationActive(loc)")
            img(:src="getActiveIcon(loc)" alt="active location icon")
          .inactive-icon(v-else)
            img(:src="icons.whiteIcon" alt="inactive location icon")
        .text
          .xs-f-medium.bold.max-at-tweak.mb-50m {{ getLocationName(loc) }}
          .xs-f-small.max-at-tweak.ui-color-6 {{ loc.address1 }}, {{ loc.city }}
          .xs-f-small.max-at-tweak.ui-color-6.mb-100m {{ loc.state }} {{ loc.zip }}
          .card-ctas.mt-50m(v-if="isLocationActive(loc)")
            a.mr-btn.btn-bloc.mb-50m.xs-f-xsmall.md-f-xxsmall.max-at-tweak(v-if="loc.type === 'MR'" :href="`/colorbar/booking/${loc.code}/services`") Book appointment
            a.underline.xs-f-small.md-f-xxsmall.max-at-tweak.upper.ui-color-9(:href="loc.mapUrl" @click.prevent="trackMREventAndRedirect('Store Locator - Get Directions clicked', loc.mapUrl)" target="blank") Get directions
          .mt-200m(v-else)
</template>
<script>

  export default {
    name: "LocationList",

    emits: ['tab-click', 'card-click'],

    props: {
      mrTabActive: {
        type: Boolean,
        default: false
      },
      mrLocations: {
        type: Array,
        default: () => []
      },
      retailLocations: {
        type: Array,
        default: () => []
      },
      activeMarker: {
        type: Object,
        default: null
      },
      icons: {
        type: Object,
        default: () => ({})
      },
    },

    computed: {

      locationList() {
        return this.mrTabActive ? this.mrLocations : this.retailLocations;
      },

      mrTabText() {
        return `Madison Reed Stores (${this.mrLocations.length})`;
      },

      retailTabText() {
        return `Retailer locations (${this.retailLocations.length})`;
      },

    },

    methods: {

      getLocationName(loc) {
        if (loc.type === "MR") {
          return `Madison Reed - ${loc.name}`;
        } else if (loc.type === "ULTA") {
          return `Ulta Beauty - ${loc.name}`;
        } else if (loc.type === "WALMART") {
          return `Walmart - ${loc.name}`;
        } else {
          return loc.name;
        }
      },


      getActiveIcon(loc) {
        let iconUrl = this.icons.whiteIcon;

        if (loc.type === "MR") {
          iconUrl = this.icons.mrIcon;
        } else if (loc.type === "ULTA") {
          iconUrl = this.icons.ultaIcon;
        } else if (loc.type === "WALMART") {
          iconUrl = this.icons.wallmartIcon;
        }

        return iconUrl;
      },

      isLocationActive(loc) {
        return (this.activeMarker?.location?.name === loc.name);
      },

    }
  };

</script>
<style lang="stylus">
  .locations
    display flex
    flex-direction column
    width 100%

    .tabs-header
      display flex
      gap 1em
      justify-content center
      border-bottom 1px solid ui-color-4
      
      .tab
        cursor pointer
        position relative
        color ui-color-6
        text-align center
        &.active
          color text-color-1
        &.active::after
          content ""
          position absolute
          bottom 0
          left 0
          width 100%
          border-bottom 2px solid cta-color-1

    .cards
      display flex
      flex-direction column
      gap 1em

      .locationCard
        display flex
        padding 1em
        border 1px solid transparent
        cursor pointer
        border-bottom 1px solid ui-color-4 

        &.active
          border 1px solid ui-color-4
          border-radius 8px
          box-shadow 0px 4px 8px 0px rgba(0, 0, 0, 0.06)

        &:has(+ .active) 
          border-bottom transparent

        .icon
          width 4em
          display flex
          justify-content center

        .card-ctas
          display flex
          align-items center
          gap 1em
          flex-wrap wrap

</style>